<template>
    <div class="tile-images" v-if="imgArr.length" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <!-- ПЛИТКА КАРТИНОК -->
        <!-- {{imgArr}} -->
        <div class="column-container">
            <div class="col">
                <img :src="imgArr[0][0].img" alt="SOHO" class="top">
                <img :src="imgArr[0][1].img" alt="SOHO" class="bottom">
            </div>
            <div class="col">
                <img :src="imgArr[0][2].img" alt="SOHO" class="top">
                <img :src="imgArr[0][3].img" alt="SOHO" class="bottom">
            </div>
            <div class="col">
                <img :src="imgArr[0][4].img" alt="SOHO" class="main">
            </div>
            <div class="col">
                <img :src="imgArr[0][5].img" alt="SOHO" class="top">
                <img :src="imgArr[0][6].img" alt="SOHO" class="bottom">
            </div>
            <div class="col">
                <img :src="imgArr[0][7].img" alt="SOHO" class="top">
                <img :src="imgArr[0][8].img" alt="SOHO" class="bottom">
            </div>
            <div class="col">
                <img :src="imgArr[0][9].img" alt="SOHO" class="main">
            </div>
            <div class="soho-logo">
                <img :src="setup.logo_white" alt="">
            </div>
        </div>
        <!-- </div> -->
        <!-- <div class="column-container" id="scene">
            <div class="col">
                <img :src="imgArr[0][0].img" alt="SOHO" class="top">
                <img :src="imgArr[0][1].img" alt="SOHO" class="bottom">
            </div>
            <div class="col">
                <img :src="imgArr[0][2].img" alt="SOHO" class="top">
                <img :src="imgArr[0][3].img" alt="SOHO" class="bottom">
            </div>
            <div class="col">
                <img :src="imgArr[0][4].img" alt="SOHO" class="main">
            </div>
            <div class="col">
                <img :src="imgArr[0][5].img" alt="SOHO" class="top">
                <img :src="imgArr[0][6].img" alt="SOHO" class="bottom">
            </div>
            <div class="col">
                <img :src="imgArr[0][7].img" alt="SOHO" class="top">
                <img :src="imgArr[0][8].img" alt="SOHO" class="bottom">
            </div>
            <div class="col">
                <img :src="imgArr[0][9].img" alt="SOHO" class="main">
            </div>
        </div> -->
    </div>
</template>

<script>
    import { ParallaxContainer, ParallaxElement } from 'vue-mouse-parallax'
    import {mapGetters} from 'vuex'
    export default {
        name: 'tile-images',
        props: ['imgArr'],
        components: {
            ParallaxContainer,
            ParallaxElement,
        },
        data () {
            return {
                intersectionOptions: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: [0.15,0.55]
                },
            }
        },
        methods: { 
            runParallax() {
                var scene = document.getElementById('scene');
                var parallaxInstance = new Parallax(scene, {
                    relativeInput: true
                });
                console.log('init')
            },
            onWaypoint ({ el, going, direction }) {
                if (this.$waypointMap.GOING_IN === going) {
                    el.classList.add('animate');
                }
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
        }),
        created () {
        },
        mounted () {
            // this.runParallax();
            // console.log(this.imgArr)
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/tile-images/tile-images.scss';
    @import '@/styles/components/tile-images/tile-images-respond.scss';
</style>